<template>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-title class="primary lighten-1 white--text headline">Settings</v-card-title>
          <v-card-text>
          <v-list two-line subheader>
            <v-subheader>User</v-subheader>
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Current Logged In User</v-list-tile-title>
                <v-list-tile-sub-title> </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>

            <v-subheader>Facility and Points</v-subheader>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Current Facility</v-list-tile-title>
                <v-list-tile-sub-title>
                    {{$store.state.pointsListStore.pointsList.facility_name}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Equipment List and Points</v-list-tile-title>
                <v-list-tile-sub-title>
                    Equipment: {{$store.state.pointsListStore.pointsList.equipment_names.length}}
                    Points: {{totalPoints}}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>


              <v-subheader>Setting</v-subheader>

            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>Sampling Frequency</v-list-tile-title>
                <v-list-tile-sub-title>
                    {{$store.state.pointsListStore.pointsList.sampling_freq}}
                    sample{{$store.state.pointsListStore.pointsList.sampling_freq==1?'':'s'}} every hour
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
            </v-card-text>
        </v-card>
      </v-flex>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="accent white--text subheading">
                    Currency and Energy Pricing
                </v-card-title>
                <v-card-text>
                        <v-data-table
                                :headers="headers"
                                disable-initial-sort
                                :items="elecPrice"
                                :rows-per-page-items="[10,25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        >
                            <template v-slot:items="props">
                                <td class="text-xs-left">{{ props.item.name }}</td>
                                <td class="text-xs-left">{{currency }} {{ props.item.price }} per kWh</td>

                            </template>
                        </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="accent white--text subheading">
                    Points List
                </v-card-title>
                <v-card-text>
                    <points-draggable disabled></points-draggable>

                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <v-card flat>
                <v-card-title class="accent white--text subheading">
                    Current Facility
                </v-card-title>
                <v-card-text>
                    <facility-switch></facility-switch>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import PointsDraggable from "../components/multiplots/PointsDraggable";
  import FacilitySwitch from '../components/FacilitySwitch'
  export default {
    name: 'Settings',
    components: { FacilitySwitch,  PointsDraggable},
    computed: {
        headers(){return [
            {
                text: 'Equipment',
                align: 'left',
                sortable: true,
                value: 'name'
            },
            {
                text: 'Energy Price',
                align: 'left',
                sortable: true,
                value: 'name'
            },

        ]},
      totalPoints () {
        let output = 0
        for (let i in this.$store.state.pointsListStore.pointsList.sensors){
          output += this.$store.state.pointsListStore.pointsList.sensors[i].length
        }
        return output
      },
        currency(){
          return this.$store.state.pointsListStore.pointsList.currency
        },
        elecPrice(){
            let items=[]
            for (let k in this.$store.state.pointsListStore.pointsList.electricityPrice){
                items.push({
                    name:k,
                    price:this.$store.state.pointsListStore.pointsList.electricityPrice[k]
                })
            }
            return items
        }
    }
  }
</script>

<style scoped>

</style>
